import React from 'react'
import { AdminSidebarLayout } from '../../components/AdminSidebar'
import { AdminHeader } from '../../components/components'
import GigsTable from '../../components/Tables/GigsTable'
import OrdersTable from '../../components/Tables/OrdersTable'

const Projects = () => {
    return (

        <AdminSidebarLayout currentPath="/projects">
            <div className="bg-[#F5F5F5] dark:bg-[#121212] min-h-screen px-4 py-8">
                <AdminHeader/>
                <div className="container mx-auto">
                    <OrdersTable/>
                </div>
            </div>
        </AdminSidebarLayout>
    )
}

export default Projects